<template>
  <div class="risk-alert-center">
    <div class="page-header">
      <h2>异常预警中心</h2>
      <p>集中查看退款、免费单等异常风险提示</p>
    </div>

    <div class="page-content">
      <div class="toolbar">
        <input v-model="startTime" type="datetime-local" class="time-input" />
        <span class="split">至</span>
        <input v-model="endTime" type="datetime-local" class="time-input" />
        <button class="search-btn" :disabled="loading" @click="loadCenter">
          {{ loading ? '加载中...' : '查询' }}
        </button>
      </div>

      <div class="overview-grid">
        <div class="overview-card">
          <div class="label">退款金额</div>
          <div class="value danger">{{ formatMoney(center.summary.refundAmount) }}</div>
        </div>
        <div class="overview-card">
          <div class="label">退款笔数</div>
          <div class="value">{{ center.summary.refundCount || 0 }}</div>
        </div>
        <div class="overview-card">
          <div class="label">免费单金额</div>
          <div class="value warning">{{ formatMoney(center.summary.freeOrderAmount) }}</div>
        </div>
        <div class="overview-card">
          <div class="label">免费单笔数</div>
          <div class="value">{{ center.summary.freeOrderCount || 0 }}</div>
        </div>
      </div>

      <div class="panel">
        <div class="panel-header">
          <h3>风险提示</h3>
          <span class="meta">共 {{ center.riskHints.length }} 条</span>
        </div>
        <div v-if="center.riskHints.length === 0" class="empty-block">当前时间范围暂无异常提示</div>
        <div v-else class="hint-list">
          <div v-for="item in center.riskHints" :key="item.code" class="hint-card">
            <div class="hint-top">
              <span :class="['level', item.level || 'info']">{{ getLevelLabel(item.level) }}</span>
              <strong>{{ item.title }}</strong>
            </div>
            <div class="hint-desc">{{ item.description }}</div>
            <div class="hint-meta">
              <span>次数：{{ item.count || 0 }}</span>
              <span>金额：{{ formatMoney(item.amount) }}</span>
              <span>对象：{{ item.subject || '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="panel">
        <div class="panel-header">
          <h3>最近异常记录</h3>
          <span class="meta">最多展示 20 条</span>
        </div>
        <div v-if="center.recentAlerts.length === 0" class="empty-block">暂无异常记录</div>
        <div v-else class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>类型</th>
                <th>门店</th>
                <th>顾客</th>
                <th>设备</th>
                <th>金额</th>
                <th>说明</th>
                <th>时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in center.recentAlerts" :key="`${item.alertType}-${index}`">
                <td>{{ item.alertType }}</td>
                <td>{{ item.storeName || '-' }}</td>
                <td>{{ item.customerName || '-' }}</td>
                <td>{{ item.deviceName || '-' }}</td>
                <td>{{ formatMoney(item.amount) }}</td>
                <td>{{ item.description || '-' }}</td>
                <td>{{ formatDateTime(item.occurredTime) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

function formatDateTimeLocal(date) {
  const target = date instanceof Date ? date : new Date(date)
  const year = target.getFullYear()
  const month = String(target.getMonth() + 1).padStart(2, '0')
  const day = String(target.getDate()).padStart(2, '0')
  const hour = String(target.getHours()).padStart(2, '0')
  const minute = String(target.getMinutes()).padStart(2, '0')
  return `${year}-${month}-${day}T${hour}:${minute}`
}

export default {
  name: 'RiskAlertCenter',
  data() {
    const now = new Date()
    const start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
    return {
      loading: false,
      startTime: formatDateTimeLocal(start),
      endTime: formatDateTimeLocal(now),
      center: {
        summary: {
          refundAmount: 0,
          refundCount: 0,
          freeOrderAmount: 0,
          freeOrderCount: 0
        },
        riskHints: [],
        recentAlerts: []
      }
    }
  },
  mounted() {
    this.loadCenter()
  },
  methods: {
    async loadCenter() {
      if (!this.startTime || !this.endTime) {
        alert('请选择开始和结束时间')
        return
      }
      this.loading = true
      try {
        const response = await request.get('/api/consumption/risk-alert-center', {
          params: {
            startTime: new Date(this.startTime).toISOString(),
            endTime: new Date(this.endTime).toISOString()
          }
        })
        if (response.data.success && response.data.code === 200) {
          this.center = response.data.data || this.center
        } else {
          throw new Error(response.data.message || '获取预警中心数据失败')
        }
      } catch (error) {
        console.error('获取预警中心数据失败:', error)
        alert(error.message || '获取预警中心数据失败，请重试')
      } finally {
        this.loading = false
      }
    },
    formatMoney(value) {
      const amount = Number(value || 0)
      return `${amount.toFixed(2)}元`
    },
    formatDateTime(value) {
      if (!value) return '-'
      return new Date(value).toLocaleString('zh-CN')
    },
    getLevelLabel(level) {
      const map = {
        high: '高风险',
        medium: '中风险',
        low: '低风险',
        info: '提示'
      }
      return map[level] || '提示'
    }
  }
}
</script>

<style scoped>
.risk-alert-center {
  height: 100%;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  margin: 0 0 8px;
  font-size: 24px;
  color: #333;
}

.page-header p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.page-content {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.time-input {
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

.split {
  color: #666;
}

.search-btn {
  padding: 8px 18px;
  border: none;
  border-radius: 4px;
  background: #1890ff;
  color: #fff;
  cursor: pointer;
}

.search-btn:disabled {
  background: #8cbcf0;
  cursor: not-allowed;
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.overview-card {
  padding: 18px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #edf2f7;
}

.label {
  color: #666;
  font-size: 13px;
}

.value {
  margin-top: 8px;
  font-size: 26px;
  font-weight: 600;
  color: #222;
}

.value.danger {
  color: #cf1322;
}

.value.warning {
  color: #d48806;
}

.panel {
  margin-top: 20px;
  border: 1px solid #eef2f6;
  border-radius: 8px;
  overflow: hidden;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px;
  border-bottom: 1px solid #eef2f6;
  background: #fafcff;
}

.panel-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.meta {
  color: #888;
  font-size: 12px;
}

.empty-block {
  padding: 24px;
  color: #888;
  text-align: center;
}

.hint-list {
  display: grid;
  gap: 12px;
  padding: 16px;
}

.hint-card {
  padding: 14px 16px;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  background: #fff;
}

.hint-top {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #222;
}

.level {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 12px;
}

.level.high {
  background: #fff1f0;
  color: #cf1322;
}

.level.medium {
  background: #fff7e6;
  color: #d48806;
}

.level.low,
.level.info {
  background: #e6f7ff;
  color: #096dd9;
}

.hint-desc {
  margin-top: 8px;
  color: #555;
  line-height: 1.6;
}

.hint-meta {
  display: flex;
  gap: 18px;
  margin-top: 10px;
  color: #666;
  font-size: 13px;
}

.table-container {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th,
.data-table td {
  padding: 12px 14px;
  border-bottom: 1px solid #f0f0f0;
  text-align: left;
  font-size: 14px;
  color: #333;
}

.data-table th {
  background: #fafafa;
  font-weight: 600;
}
</style>
